<template>
  <VuelidateField :validation="v$.industryId">
    <template #default="{ error, state }">
      <FieldWrapper for="industry-select" :label="t('Reviews.agency.edit.industry.label').toString()" :error="error" class="mb-8">
        <template #default="{ id: inputId }">
          <SelectField
            :id="inputId"
            v-model="v$.industryId.$model"
            :placeholder="t('Reviews.agency.edit.industry.placeholder').toString()"
            :state="state"
          >
            <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name }}</option>
          </SelectField>
        </template>
      </FieldWrapper>
    </template>
  </VuelidateField>
</template>

<script setup lang="ts">
import { FieldWrapper, SelectField } from '@ramp106/omrjs-core-ui'
import { useVuelidate } from '@vuelidate/core'
import { computed, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { required, uniqueArrayElement } from '@/services/validators'
import VuelidateField from '@/ui/VuelidateField.vue'

import type { IndustryFormData } from './types'

const props = defineProps<{
  modelValue: IndustryFormData
  selectedIndustries: string[]
  options: { name: string; id: string }[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: IndustryFormData): void
}>()

const { t } = useI18n()

const formData = reactive<IndustryFormData>({
  ...props.modelValue,
})

const rules = computed(() => ({
  industryId: { required, uniqueArrayElement: uniqueArrayElement(() => props.selectedIndustries || [], props.modelValue._destroy) },
}))

const v$ = useVuelidate(rules, formData)

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal?.industryId) {
      formData.industryId = newVal.industryId
    }
  },
)

watch(
  () => formData,
  () => {
    emit('update:modelValue', formData)
  },
  { deep: true },
)
</script>
